import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';

interface UpdateUserVars {
    data: {
        id: number,
        disabled: boolean
    };
}

interface UpdateUserData {
    updateUser: User
}

export const UPDATE_USER_MUTATION = gql`
    mutation disableUser($data: UpdateUserInput!) {
        updateUser(data: $data) {
          id
          disabled
        }
    }
`;

export const disableUser = () => useMutation<UpdateUserData, UpdateUserVars>(
    UPDATE_USER_MUTATION,
    {}
);

export default disableUser;